module.exports = __webpack_public_path__ + "img/IMG_3119_L_WoodMatted.294d0b53.jpg";